import { useEffect, useState } from 'react';
import { CheckRounded, ExpandMore, PublicOutlined } from '@mui/icons-material';
import { Box, Popover, Typography } from '@mui/material';
import clsx from 'clsx';
import { getCountryNormalLogoUrl } from '../../utils/country';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveInternationalizationCountrySwitchView = function JoveInternationalizationCountrySwitchView(props) {
  var className = props.className,
      countryList = props.countryList,
      value = props.value,
      valueChange = props.valueChange,
      promotionInfo = props.promotionInfo;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(null),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(countryList || []),
      canSelectCountryList = _useState3[0],
      setCanSelectCountryList = _useState3[1];

  var _useState4 = useState(value),
      selectedCountry = _useState4[0],
      setSelectedCountry = _useState4[1];
  /**
   * effects
   */


  useEffect(function () {
    setCanSelectCountryList(countryList || []);
  }, [countryList]);
  useEffect(function () {
    setSelectedCountry(value);
  }, [value]);
  /**
   * methods
   */

  var openSwitchCountryAction = function openSwitchCountryAction(event) {
    setIsOpen(true);
    setAnchorEl(event.currentTarget);
  };

  var closeSwitchCountryAction = function closeSwitchCountryAction() {
    setAnchorEl(null);
    setIsOpen(false);
  };

  var selectCountryAction = function selectCountryAction(item) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item === null || item === void 0 ? void 0 : item.value);
    closeSwitchCountryAction();
  };

  return (canSelectCountryList === null || canSelectCountryList === void 0 ? void 0 : canSelectCountryList.length) <= 1 && !!promotionInfo ? null : /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsxs("button", {
      role: "button",
      onClick: openSwitchCountryAction,
      className: clsx('pointer group flex items-center self-center rounded-full border-2 px-3 py-2 transition-all duration-300 ease-out hover:border-stone-600', isOpen && 'border-stone-600 bg-gray-100'),
      children: [selectedCountry ? /*#__PURE__*/_jsx("img", {
        className: "h-auto w-7",
        src: getCountryNormalLogoUrl(selectedCountry),
        alt: selectedCountry
      }) : /*#__PURE__*/_jsx(PublicOutlined, {}), /*#__PURE__*/_jsx(ExpandMore, {
        className: clsx('w-5 text-stone-400 transition-all duration-300 ease-out group-hover:text-stone-900', isOpen && 'rotate-180 text-stone-900')
      })]
    }), /*#__PURE__*/_jsx(Popover, {
      id: "jove-internationalization-country-switch-popover",
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: closeSwitchCountryAction,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: -130
      },
      className: "rounded-2xl",
      children: /*#__PURE__*/_jsx(Box, {
        className: "flex w-[200px] flex-col p-2 text-left",
        children: canSelectCountryList.map(function (item) {
          if (!item) {
            return null;
          }

          var selected = selectedCountry === item.value;
          return /*#__PURE__*/_jsxs(Box, {
            onClick: function onClick() {
              return selectCountryAction(item);
            },
            className: clsx('flex cursor-pointer flex-row items-center space-x-2 rounded-sm p-2 text-left text-sm font-medium transition-all duration-300 ease-out hover:bg-slate-100', selected && 'bg-slate-100'),
            children: [/*#__PURE__*/_jsx("img", {
              className: "h-auto w-8",
              src: getCountryNormalLogoUrl(item === null || item === void 0 ? void 0 : item.value),
              alt: item === null || item === void 0 ? void 0 : item.value
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "subtitle2",
              className: "w-0 flex-1 font-medium",
              children: item.label
            }), selected && /*#__PURE__*/_jsx(CheckRounded, {
              className: "ml-auto w-4"
            })]
          }, item.value);
        })
      })
    })]
  });
};